import { useState, useEffect } from 'react';
import { authService } from '../../../../../services/api';

const thumbCache = new Map();

export default function TelegramThumb({ fileId, botId, imgClassName = 'rounded w-full max-h-32 object-cover' }) {
    const [src, setSrc] = useState(null);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        if (!fileId || !botId) { setStatus('error'); return; }
        let cancelled = false;

        const cacheKey = `${botId}:${fileId}`;

        if (thumbCache.has(cacheKey)) {
            thumbCache.get(cacheKey)
                .then((url) => { if (!cancelled) { setSrc(url); setStatus('ok'); } })
                .catch(() => { if (!cancelled) setStatus('error'); });
            return () => { cancelled = true; };
        }

        setStatus('loading');
        setSrc(null);

        const promise = authService.uploads.telegram_preview(fileId, botId)
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'image/jpeg',
                });
                return URL.createObjectURL(blob);
            });

        thumbCache.set(cacheKey, promise);

        promise
            .then((url) => { if (!cancelled) { setSrc(url); setStatus('ok'); } })
            .catch((e) => {
                thumbCache.delete(cacheKey);
                if (!cancelled) { console.warn('[TelegramThumb] erro:', e.message); setStatus('error'); }
            });

        return () => { cancelled = true; };
    }, [fileId, botId]);

    if (status === 'error') return (
        <div className="flex items-center gap-1 rounded bg-white/5 px-2 py-1 text-[10px] text-gray-500">
            <i className="fas fa-image" /> sem preview
        </div>
    );
    if (status === 'loading') return (
        <div className="flex items-center gap-1 rounded bg-white/5 px-2 py-1 text-[10px] text-gray-400">
            <i className="fas fa-spinner fa-spin" /> carregando...
        </div>
    );
    return <img src={src} alt="" className={imgClassName} />;
}
